// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// sembrar.pasto@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBJMXpUyKL1xsG0fIKDVOLt4Go4VZA5fq8",
    authDomain: "sembrar-semilleros.firebaseapp.com",
    projectId: "sembrar-semilleros",
    storageBucket: "sembrar-semilleros.firebasestorage.app",
    messagingSenderId: "847643776821",
    appId: "1:847643776821:web:9e63982c5578f5dc7dde7c",
    measurementId: "G-72CHSLR6QG"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)